import {Box, Heading, HStack} from 'platform/foundation';
import {useFormatCurrency} from 'platform/locale';

import {useCallback} from 'react';

import {defaultTo, mergeAll} from 'ramda';

import {GetIssueNoteCorrectionResponse} from '@dms/api/warehouse';
import i18n from '@dms/i18n';
import {DmsDataGrid, WAREHOUSE_GRID_CODES, useTenant} from '@dms/shared';
import {useWarehouseParams} from '@dms/warehouse/shared-components';

import {Nullish, RequiredTestIdProps, suffixTestId} from 'shared/web';

import type {QueryFilterObject} from 'features/eag-grid';

interface ListOfItemsTabProps extends RequiredTestIdProps {
  issueNoteCorrection: GetIssueNoteCorrectionResponse | Nullish;
}

export function ListOfItemsTab(props: ListOfItemsTabProps) {
  const {issueNoteCorrectionId} = useWarehouseParams();
  const tenant = useTenant();
  const formatCurrency = useFormatCurrency();

  const queryModifier = useCallback(
    (filter: QueryFilterObject) => mergeAll([filter, {issueNoteCorrectionId}]),
    [issueNoteCorrectionId]
  );

  const totalValue = formatCurrency(
    defaultTo(0, props.issueNoteCorrection?.summaryInformation.totalValue.amount),
    defaultTo(
      tenant.tenantCurrency,
      props.issueNoteCorrection?.summaryInformation.totalValue.currency
    ),
    2
  );

  return (
    <>
      <Box height="95%">
        <DmsDataGrid
          gridCode={WAREHOUSE_GRID_CODES.warehouseIssueNoteCorrectionItems}
          queryModifier={queryModifier}
          data-testid={suffixTestId('issuedItems', props)}
        />
      </Box>
      <HStack height={10} align="center" justify="space-between">
        <Heading size={5}>{i18n.t('general.labels.totalValue')}</Heading>
        <Heading size={5}>{totalValue}</Heading>
      </HStack>
    </>
  );
}
